import React, {useEffect, useState} from "react";
import "./../../utils/Style/pages/Banktransfers.scss";
import useCommonAPI from "../../api/CommonAPI";
import {useOutletContext} from "react-router-dom";
import {useDispatch} from "react-redux";
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import BlurLoading from "../../components/BlurLoading";

function SuyoulBulkTransferTemplate() {
    const {getAllCurrencies, currencies} = useCommonAPI();

    const [onOpenQrAfterGenerate] = useOutletContext();
    const dispatch = useDispatch();

    const [selectedFile, setSelectedFile] = useState(new File([], ""));
    const [payload, setPayload] = useState({
        CurrencyID: "",
        ReasonFileName: "",
        formFile: null,
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        getAllCurrencies();
    }, []);


    useEffect(() => {
        if (selectedFile) {
            const reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onloadend = () => {
                const base64String = reader.result;
                setPayload((prevState) => ({
                    ...prevState,
                    ReasonFileName: selectedFile.name,
                    formFile: base64String
                }));
            };

        }
    }, [selectedFile]);

    const handleChange = (event) => {
        const {name, value} = event.target;
        setPayload({...payload, [name]: value});
        setErrors({...errors, [name]: ""});
    };


    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!payload.CurrencyID) {
            newErrors.CurrencyID = "Account is required.";
            isValid = false;
        }

        if (selectedFile === undefined || selectedFile.name === undefined || selectedFile.size <= 0) {
            newErrors.formFile = "File upload is required.";
            isValid = false;
        } else if (!/\.xlsx?$/.test(selectedFile.name.toLowerCase())) {
            newErrors.formFile = "Only Excel files are allowed.";
            isValid = false;
        }

        const fileSizeLimit = 2 * 1024 * 1024; // 2 MB
        if (selectedFile && selectedFile.size > fileSizeLimit){
            newErrors.formFile = "File should not be larger than 2MB.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (validateForm()) {
            dispatch(setActionType(ACTION_TYPES.PUSH_BULK_S2S_TRANSFER));
            dispatch(setActionPayload(payload));

            onOpenQrAfterGenerate();
        }
    };

    return (
        <div className="BanktransfersPage">
            <div className="NewTransferTemplate">
                {<BlurLoading/>}
                <div className="title">Transfer money to 2 & more users</div>
                <form className="NewTransferTemplate" onSubmit={handleSubmit} autoComplete="off">
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">From Account</div>
                        <div className="col-lg-6 col-md-7">
                            <select
                                className={!payload.CurrencyID || payload.CurrencyID==="0"? "placeholder-color ddselect": "ddselect"}
                                name="CurrencyID"
                                id="account"
                                value={payload.CurrencyID}
                                onChange={handleChange}
                            >
                                <option value="0">Select one value Only</option>
                                {currencies && currencies.map(({label, value}) => (
                                    <option key={value} value={value}>{label}</option>
                                ))
                                }
                            </select>
                            {errors.CurrencyID && (
                                <span className="error">{errors.CurrencyID}</span>
                            )}
                        </div>
                    </div>
                    <div className="title">Recipients Information (Download <a className="clickable-file"
                                                                                  href={sessionStorage.getItem("S2sTransferTemplate")}>.CSV
                        sample file</a>)
                    </div>
                    <div className="row dataEntry">
                        <div className="col-lg-3 col-md-3 subTitle">Upload File</div>
                        <div className="col-lg-6 col-md-7">
                            <input type="file"
                                   id="myFile"
                                   name="formFile"
                                   className="placeholder-color"
                                   onClick={
                                       (e) => {
                                           e.target.value = null;
                                           setErrors({...errors, formFile: ""});
                                       }
                                   }
                                   onChange={
                                       (e) => {
                                           setSelectedFile(e.target.files[0])
                                       }
                                   }/>
                            {errors.formFile && (
                                <span className="error">{errors.formFile}</span>
                            )}
                        </div>
                    </div>
                    <div className="row submitForm">
                        <div className="btn_place">
                            <button type="submit" className="submitBtn">Confirm</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default SuyoulBulkTransferTemplate;